const getLanguage = ({ user }) => user.getIn(['language'], 'en-US')
const getTheme = ({ user }) => user.getIn(['theme'], {})

export default (state) => {
  return {
    language: getLanguage(state),
    isDark: getTheme(state).black != null ? true : false
  }
}